import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as AddIconSVG } from "assets/icons/plus.svg";
import React from "react";
import successLogo from "../../../assets/icons/eventSuccessfull.svg";
import MyButton from "../../../components/MyButton";
import { colors } from "./newEventColors";
import NewEventSuccessTask from "./NewEventSuccessTask";

const NewEventSuccess = ({
  eventType,
  fullName,
  closeModal,
  successEventData,
  doNotGenerateHandler,
  updateEventLoading,
}) => {
  const getCardColor = (unit, recurring) => {
    let randomIndex = 0;
    if (recurring === 0) {
      switch (unit?.toLowerCase()) {
        case "day":
          randomIndex = 0;
          break;
        case "month":
          randomIndex = 1;
          break;
        case "year":
          randomIndex = 2;
          break;
        default:
          randomIndex = 0;
          break;
      }
    } else {
      randomIndex = 3;
    }
    return {
      bgColor: colors.bgColors[randomIndex],
      textColor: colors.textColors[randomIndex],
    };
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100">
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
        <img src={successLogo} />
        <h1 className="event-successful-h mb-2 mt-2">
          Event Successfully Created
        </h1>
        <p className="event-successful-p">
          {eventType} has been added successfully to {fullName}
        </p>
        <div className="event-tasks__container">
          <p className="event-task-box-title">Tasks for this event</p>
          <ul
            className="event-tasks__container__list pastoral-scroll-x p-2"
            style={{
              minHeight: "270px",
              maxHeight: "270px",
            }}
          >
            {successEventData?.map((item, index) => {
              return item?.displayText ? (
                <NewEventSuccessTask
                  key={index}
                  index={index}
                  getCardColor={getCardColor}
                  item={item}
                />
              ) : null;
            })}
          </ul>
        </div>
      </div>
      <div className="d-flex justify-content-between w-100 mt-4">
        <div className="success-btn">
          <MyButton
            type={"secondary"}
            content={
              updateEventLoading ? (
                <div className="d-flex align-items-center justify-content-center">
                  <CircularProgress
                    size={20}
                    style={{
                      color: "#ffffff",
                    }}
                  />
                </div>
              ) : (
                "Do not generate tasks and confirm"
              )
            }
            onClick={doNotGenerateHandler}
            disabled={updateEventLoading}
          />
        </div>
        <div className="success-btn width-success">
          <MyButton type={"primary"} content={"Ok"} onClick={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default NewEventSuccess;
